import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

const ScrollToHashElement = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check for section query parameter
    const sectionId = searchParams.get("section");

    if (sectionId) {
      // Small delay to ensure DOM is fully rendered
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          // Clean up the URL by removing the query parameter
          window.history.replaceState({}, document.title, location.pathname);
        }
      }, 100);
    }
  }, [location.pathname, searchParams]);

  return null;
};

export default ScrollToHashElement;
